import { useEffect, useRef, useState } from "react";
import { X, Upload, Trash2, Check } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";

export default function MediaPicker({ open, onClose, onSelect }) {
  const [items, setItems] = useState([]);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const load = () => api.get("/admin/media").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { if (open) load(); }, [open]);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/media", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await load();
      onSelect(mediaUrl(data.url));
      onClose();
    } catch (err) {
      alert("Upload failed: " + (err.response?.data?.detail || err.message));
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  const del = async (id, e) => {
    e.stopPropagation();
    if (!window.confirm("Delete this image?")) return;
    await api.delete(`/admin/media/${id}`);
    load();
  };

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] bg-lp-ink/60 flex items-center justify-center p-4" onClick={onClose} data-testid="media-picker">
      <div className="bg-white rounded-sm max-w-3xl w-full max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between p-5 border-b border-lp-border">
          <h3 className="font-heading font-700 text-xl text-lp-blue">Media Library</h3>
          <div className="flex items-center gap-3">
            <button onClick={() => fileRef.current?.click()} disabled={uploading} data-testid="media-upload-btn" className="inline-flex items-center gap-2 bg-lp-blue text-white font-600 px-4 py-2 rounded-sm text-sm disabled:opacity-60">
              <Upload size={15} /> {uploading ? "Uploading…" : "Upload"}
            </button>
            <input ref={fileRef} type="file" accept="image/*" className="hidden" onChange={upload} />
            <button onClick={onClose}><X size={22} className="text-lp-muted" /></button>
          </div>
        </div>
        <div className="p-5 overflow-y-auto grid grid-cols-3 sm:grid-cols-4 gap-3">
          {items.map((m) => (
            <button key={m.id} onClick={() => { onSelect(mediaUrl(m.url)); onClose(); }} className="group relative border border-lp-border rounded-sm overflow-hidden aspect-square hover:border-lp-cyan">
              <img src={mediaUrl(m.url)} alt={m.original_filename} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-lp-blue/0 group-hover:bg-lp-blue/30 flex items-center justify-center transition-colors">
                <Check size={26} className="text-white opacity-0 group-hover:opacity-100" />
              </div>
              <span onClick={(e) => del(m.id, e)} className="absolute top-1 right-1 bg-white/90 rounded-sm p-1 text-destructive opacity-0 group-hover:opacity-100"><Trash2 size={14} /></span>
            </button>
          ))}
          {items.length === 0 && <p className="col-span-full text-center text-lp-muted py-10">No media yet. Upload your first image.</p>}
        </div>
      </div>
    </div>
  );
}
